import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Music2 } from "lucide-react";
import { api } from "@/lib/api";
import { waLink, WA_DEFAULT, WA_DISPLAY } from "@/lib/wa";
import { trackWhatsApp, trackPhone } from "@/lib/analytics";

export function Footer() {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <footer className="grain relative bg-navy text-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-4 md:px-12 md:py-20">
        <div className="md:col-span-1">
          <div className="inline-block rounded-xl bg-white p-3">
            <img src="/images/logo-sm.webp" srcSet="/images/logo-sm-160.webp 160w, /images/logo-sm.webp 400w" sizes="66px" alt="Bella Film RJ" className="h-10 w-auto" width="66" height="40" loading="lazy" />
          </div>
          <p className="mt-5 text-sm leading-relaxed text-white/70">
            Instalação profissional de insulfilm residencial, comercial e automotivo no Rio de Janeiro desde 2010.
          </p>
        </div>
        <div>
          <p className="font-display text-sm font-bold uppercase tracking-[0.2em] text-aqua">Contato</p>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            <li>
              <a href={waLink(WA_DEFAULT)} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp"
                 onClick={() => trackWhatsApp("footer", "WhatsApp rodapé")} className="transition-colors hover:text-aqua">
                WhatsApp: {WA_DISPLAY}
              </a>
            </li>
            <li>
              <a href="tel:+552120184446" data-testid="footer-telefone" onClick={trackPhone} className="transition-colors hover:text-aqua">
                Telefone: {WA_DISPLAY}
              </a>
            </li>
            <li>
              <a href="mailto:bellafilmrj@gmail.com" data-testid="footer-email" className="transition-colors hover:text-aqua">
                bellafilmrj@gmail.com
              </a>
            </li>
            <li className="text-white/60">Rua do Matoso – Tijuca – Rio de Janeiro</li>
            <li className="text-white/60">Atendemos toda a cidade do Rio de Janeiro</li>
            <li className="text-white/60">Segunda a sexta, das 9h às 17h</li>
          </ul>
        </div>
        <div>
          <p className="font-display text-sm font-bold uppercase tracking-[0.2em] text-aqua">Navegação</p>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            <li><Link to="/" data-testid="footer-link-inicio" className="transition-colors hover:text-aqua">Início</Link></li>
            <li><Link to="/catalogo-insulfilm-rj" data-testid="footer-link-catalogo" className="transition-colors hover:text-aqua">Catálogo</Link></li>
            <li><Link to="/servicos" data-testid="footer-link-servicos" className="transition-colors hover:text-aqua">Serviços</Link></li>
            <li><Link to="/orcamento" data-testid="footer-link-orcamento" className="transition-colors hover:text-aqua">Orçamento</Link></li>
            <li><Link to="/duvidas-sobre-insulfilm" data-testid="footer-link-duvidas" className="transition-colors hover:text-aqua">Dúvidas</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-display text-sm font-bold uppercase tracking-[0.2em] text-aqua">Redes sociais</p>
          <div className="mt-5 flex gap-3">
            <a href="https://www.instagram.com/bellafilmrj/" target="_blank" rel="noopener noreferrer"
               data-testid="footer-instagram" aria-label="Instagram @bellafilmrj"
               className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-aqua">
              <Instagram size={19} />
            </a>
            {settings.facebook_url && (
              <a href={settings.facebook_url} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook"
                 aria-label="Facebook da Bella Film RJ"
                 className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-aqua">
                <Facebook size={19} />
              </a>
            )}
            {settings.tiktok_url && (
              <a href={settings.tiktok_url} target="_blank" rel="noopener noreferrer" data-testid="footer-tiktok"
                 aria-label="TikTok da Bella Film RJ"
                 className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-aqua">
                <Music2 size={19} />
              </a>
            )}
          </div>
          <p className="mt-5 text-sm text-white/70">@bellafilmrj</p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-6 text-xs text-white/50 md:flex-row md:items-center md:justify-between md:px-12">
          <span>© {new Date().getFullYear()} Bella Film RJ — Insulfilm no Rio de Janeiro</span>
          <span>Desde 2010 · Atendimento em toda a cidade do Rio de Janeiro</span>
        </div>
      </div>
    </footer>
  );
}
